var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM45.6596 24.261C46.6454 23.0289 46.4456 21.2309 45.2134 20.2451C43.9812 19.2594 42.1833 19.4592 41.1975 20.6913L27.6894 37.5765L22.2857 33.5238C21.0233 32.577 19.2325 32.8329 18.2857 34.0952C17.3389 35.3576 17.5948 37.1485 18.8571 38.0952L26.4762 43.8095C27.7108 44.7355 29.4575 44.5137 30.4215 43.3087L45.6596 24.261Z",
    fill: "#4BC671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucc);
export default __webpack_public_path__ + "static/media/succ.83afeea1f0277cb28c43c95639b632cb.svg";
export { ForwardRef as ReactComponent };